import { Card, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import Icon from "../generic/Icon";
import { useSiteContext } from "./Providers/SSCProvider";
import { useState } from "react";

const Filtering = () => {
  const {
    filterValue,
    handleFilter,
    formData,
    selectedOptions,
    setSelectedOptions,
  } = useSiteContext();

  return (
    <Container fluid className="mt-4 p-0">
      <Card
        className="shadow-sm p-2"
        style={{ backgroundColor: "rgb(236, 236, 236)" }}
      >
        <Row className="d-flex align-items-center">
          <Col sm={3} className="d-flex align-items-center">
            <Icon
              name={"filter"}
              overrides={{
                tooltip: "",
                size: "1.2rem",
                iconColor: "grey",
                style: {
                  cursor: "default",
                  marginRight: "8px",
                },
              }}
              id="filter-icon"
            />
            <Form.Control
              //   disabled={isLoading}
              type="text"
              placeholder="Filter by Number, Carrier, LEC"
              value={filterValue}
              onChange={handleFilter}
            />
          </Col>
          <Col />

          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Status"}
              filterData={formData?.status}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Use"}
              filterData={formData?.use}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Type"}
              filterData={formData?.type}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Category"}
              filterData={formData?.category}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Scope"}
              filterData={formData?.scope}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              title={"Carrier"}
              filterData={formData?.carrier}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"LEC"}
              filterData={formData?.carrier}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          {/* <Col>
            <MyDropDown
              isDisabled={false}
              title={"Handoff Media"}
              filterData={formData?.handoffType}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col>
          <Col>
            <MyDropDown
              isDisabled={false}
              title={"Redundancy Type"}
              filterData={formData?.redundancyType}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </Col> */}
        </Row>
      </Card>
    </Container>
  );
};

const MyDropDown = ({
  title,
  isDisabled,
  filterData = [],
  selectedOptions,
  setSelectedOptions,
}) => {
  const [dropDownFilter, setDropDownFilter] = useState("");

  const filterField =
    title === "Carrier" || title === "LEC" ? "carrierName" : "name";

  const filteredData = (filterData || []).filter((item) =>
    item[filterField]?.toLowerCase().includes(dropDownFilter.toLowerCase())
  );

  const selection = title.replace(/\s+/g, "");

  const handleCheckboxChange = (key, item) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [key]: prev[key]?.includes(item)
        ? prev[key].filter((i) => i !== item)
        : [...(prev[key] || []), item],
    }));
  };

  return (
    <Dropdown
      align="start"
      onToggle={(isOpen) => {
        if (!isOpen) setDropDownFilter("");
      }}
    >
      <Dropdown.Toggle
        disabled={isDisabled}
        variant="primary"
        className="w-100 d-flex justify-content-between align-items-center"
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1px solid #ced4da",
          padding: "2px 8px",
          textAlign: "left",
          fontSize: "12px",
          height: "25px",
          width: "100%",
          fontWeight: selectedOptions[selection]?.length ? "bold" : "normal",
        }}
      >
        {title}{" "}
        {selectedOptions[selection].length > 0 && (
          <>({selectedOptions[selection].length})</>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="w-100 p-2"
        style={{
          maxHeight: "250px",
          overflow: "auto",
        }}
      >
        <Form.Control
          type="text"
          placeholder="Filter..."
          value={dropDownFilter}
          onChange={(e) => setDropDownFilter(e.target.value)}
        />
        <hr className="my-1" />

        <Form.Check
          type="checkbox"
          label="Select All"
          checked={selectedOptions[selection]?.length === filterData?.length}
          onChange={() => {
            setSelectedOptions((prev) => ({
              ...prev,
              [selection]:
                prev[selection]?.length === filterData?.length
                  ? []
                  : (filterData || []).map((s) => s[filterField]),
            }));
          }}
          className="px-3 ms-1 fw-bold"
        />
        <hr className="my-1" />

        {filteredData.map((item, index) => (
          <Form.Check
            key={index}
            type="checkbox"
            label={item[filterField]}
            checked={
              selectedOptions[selection]?.includes(item[filterField]) || false
            }
            onChange={() => handleCheckboxChange(selection, item[filterField])}
            className="px-3 ms-1"
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Filtering;
